import React, { useEffect, useState } from 'react';
import Keypad from './Keypad';

function MCQChoicesInline({ team, options, onSelect, disabled, feedback, selectedIndex }) {
  const colors = ['#E85D3A', '#2196F3', '#4CAF50', '#FF9800'];

  return (
    <div className="mcq-choices" data-testid={`${team}-mcq-choices`}>
      {(options || []).map((option, index) => {
        let btnClass = 'mcq-btn';
        if (feedback !== null && index === selectedIndex) {
          btnClass += feedback === 'correct' ? ' mcq-btn-correct' : ' mcq-btn-wrong';
        }
        return (
          <button
            key={index}
            className={btnClass}
            style={{
              background: feedback === null ? colors[index] : undefined,
              opacity: disabled && feedback === null ? 0.5 : 1
            }}
            onClick={() => !disabled && onSelect(index)}
            disabled={disabled}
            data-testid={`${team}-mcq-option-${index}`}
          >
            <span className="mcq-letter">{String.fromCharCode(65 + index)}</span>
            <span className="mcq-text">{option}</span>
          </button>
        );
      })}
    </div>
  );
}

export default function TeamPanel({
  team, teamName, question, input, feedback,
  comboText, streak, onDigit, onClear, onSubmit,
  onMCQSelect, disabled, language, isMCQ, mcqSelectedIndex
}) {
  const isTeam1 = team === 'team1';
  const teamClass = isTeam1 ? 'team-panel-1' : 'team-panel-2';
  const [animClass, setAnimClass] = useState('');

  useEffect(() => {
    if (feedback === 'correct') setAnimClass('anim-correct');
    else if (feedback === 'wrong') setAnimClass('anim-wrong');
    else setAnimClass('');
  }, [feedback]);

  const feedbackClass = feedback === 'correct' ? 'feedback-correct'
    : feedback === 'wrong' ? 'feedback-wrong' : '';

  return (
    <div className={`team-panel ${teamClass}`} data-testid={`${team}-panel`}>
      <div className="team-header">
        <div className="team-name-badge" data-testid={`${team}-name`}>{teamName}</div>
        {streak >= 3 && (
          <div className="streak-badge" data-testid={`${team}-streak`}>
            {streak >= 5 ? '\uD83D\uDD25' : '\u26A1'} x{streak}
          </div>
        )}
      </div>

      <div className={`question-card ${feedbackClass} ${animClass}`}>
        {question && (
          <div className={`question-text ${isMCQ ? 'question-text-mcq' : ''}`} data-testid={`${team}-question-text`}>
            {isMCQ ? question.question : `${question.a} ${question.op} ${question.b} = ?`}
          </div>
        )}
      </div>

      {comboText && (
        <div className={`combo-text ${streak >= 5 ? 'combo-super' : 'combo-normal'}`}>{comboText}</div>
      )}

      {isMCQ ? (
        <MCQChoicesInline
          team={team}
          options={question?.options || []}
          onSelect={(idx) => onMCQSelect && onMCQSelect(idx)}
          disabled={disabled || feedback !== null}
          feedback={feedback}
          selectedIndex={mcqSelectedIndex}
        />
      ) : (
        <>
          <div className={`answer-pill ${feedbackClass} ${animClass}`} data-testid={`${team}-answer-display`}>
            {input || '0'}
          </div>
          <Keypad team={team} onDigit={onDigit} onClear={onClear} onSubmit={onSubmit} disabled={disabled} />
        </>
      )}
    </div>
  );
}
